import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import TableList from "@/pages/TableList.vue";
import Typography from "@/pages/Typography.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Notifications from "@/pages/Notifications.vue";
import UpgradeToPRO from "@/pages/UpgradeToPRO.vue";

import login from "@/pages/login.vue";

import PostRequest from "@/pages/PostRequest/PostRequest.vue";
import NewPostItems from "@/pages/PostRequest/NewPostItems.vue";
import AcceptedItem from "@/pages/PostRequest/AcceptedItem.vue";
import RejectedItem from "@/pages/PostRequest/RejectedItem.vue";

import WantRequest from "@/pages/WantRequest/WantRequest.vue";
import NewWantRequest from "@/pages/WantRequest/NewWantRequest.vue";
import AcceptedWantItem from "@/pages/WantRequest/AcceptedItem.vue";
import RejectedWantItem from "@/pages/WantRequest/RejectedItem.vue";

import PreOrderRequest from "@/pages/PreOrder/PreOrderRequest.vue";
import NewPreOrderRequest from "@/pages/PreOrder/NewPreOrderRequest.vue";
import AcceptePreOrderRequest from "@/pages/PreOrder/AcceptePreOrderRequest.vue";
import RejectPreOrderRequest from "@/pages/PreOrder/RejectPreOrderRequest.vue";

const router = new VueRouter({
  mode: "history",

  routes: [
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/",
      component: DashboardLayout,
      meta: { conditionalRoute: true, forAuth: true },
      redirect: "/dashboard",
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        {
          path: "post-riquest",
          name: "Post Requests",
          component: PostRequest
        },
        {
          path: "post-riquest/new",
          name: "Pending Post Requests",
          component: NewPostItems
        },
        {
          path: "post-riquest/accepted",
          name: "Accepted Post Requests",
          component: AcceptedItem
        },
        {
          path: "post-riquest/rejected",
          name: "Rejected Post Requests",
          component: RejectedItem
        },
        {
          path: "want-riquest",
          name: "Want This Requests",
          component: WantRequest
        },
        {
          path: "want-riquest/new",
          name: "Want Requests",
          component: NewWantRequest
        },
        {
          path: "want-riquest/accepted",
          name: "Accepted Want Requests",
          component: AcceptedWantItem
        },
        {
          path: "want-riquest/rejected",
          name: "Rejected Want Requests",
          component: RejectedWantItem
        },
        {
          path: "pre-order-request",
          name: "Pre-Order Requests",
          component: PreOrderRequest
        },
        {
          path: "pre-order-request/new",
          name: "Pending Pre-Order Requests",
          component: NewPreOrderRequest
        },
        {
          path: "pre-order-request/accepted",
          name: "Accepted Pre-Order Requests",
          component: AcceptePreOrderRequest
        },
        {
          path: "pre-order-request/rejected",
          name: "Rejected Pre-Order Requests",
          component: RejectPreOrderRequest
        },

        {
          path: "table",
          name: "Table List",
          component: TableList
        },
        {
          path: "typography",
          name: "Typography",
          component: Typography
        },
        {
          path: "icons",
          name: "Icons",
          component: Icons
        },
        {
          path: "maps",
          name: "Maps",
          meta: {
            hideFooter: true
          },
          component: Maps
        },
        {
          path: "notifications",
          name: "Notifications",
          component: Notifications
        },
        {
          path: "upgrade",
          name: "Upgrade to PRO",
          component: UpgradeToPRO
        }
      ]
    }
  ]
});

export default router;
